/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * KonnectHub REST API Documentation
 * OpenAPI spec version: latest
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionPayload,
  Event,
  EventConnection,
  EventDispatchInput,
  EventListParams,
  EventsStreamParams
} from '.././model';

import { apiMutator } from '../../client';




/**
 * Server-Sent Events. `topics` is a comma-separated list of `execution` (any execution status change in the active workspace) and/or `event` (any trigger firing recorded in the active workspace — `id` is the new event) and/or `notification` (YOUR OWN inbox — per-user, not per-workspace, so it also carries account-level rows; `action` is `created` or `updated`, `id` the notification) and/or `presence:<flowId>` (draft-editor presence changes for that flow) and/or `publish:<flowId>` (background bundle builds for that flow — `action` is the `BundleStatus`, `id` the version being built) and/or `es:<eventSourceId>` (events recorded on that source — `id` is the new event) and/or `webhook:<webhookId>` (deliveries to that webhook) and/or `schedule:<scheduleId>` (firings of that schedule) and/or `exec:<executionId>` (one graph run: `action` is `activation` for a status transition, `progress` for a stream’s item count, or `execution` for the run’s own status). Events carry only `{topic, action, id, ts}` — clients refetch on receipt — except `exec:`, whose `data` is a redacted activation summary (status, duration, itemCount, a ≤256-byte preview, the error message); full outputs are read over REST.
 * @summary Subscribe to a live event stream (SSE)
 */
export const eventsStream = (
    params: EventsStreamParams,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<void>(
      {url: `/api/v1/events/stream`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getEventsStreamQueryKey = (params?: EventsStreamParams,) => {
    return [
    `/api/v1/events/stream`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getEventsStreamQueryOptions = <TData = Awaited<ReturnType<typeof eventsStream>>, TError = unknown>(params: EventsStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsStream>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsStreamQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsStream>>> = ({ signal }) => eventsStream(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventsStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsStreamQueryResult = NonNullable<Awaited<ReturnType<typeof eventsStream>>>
export type EventsStreamQueryError = unknown


export function useEventsStream<TData = Awaited<ReturnType<typeof eventsStream>>, TError = unknown>(
 params: EventsStreamParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsStream>>,
          TError,
          Awaited<ReturnType<typeof eventsStream>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsStream<TData = Awaited<ReturnType<typeof eventsStream>>, TError = unknown>(
 params: EventsStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsStream>>,
          TError,
          Awaited<ReturnType<typeof eventsStream>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsStream<TData = Awaited<ReturnType<typeof eventsStream>>, TError = unknown>(
 params: EventsStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsStream>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Subscribe to a live event stream (SSE)
 */

export function useEventsStream<TData = Awaited<ReturnType<typeof eventsStream>>, TError = unknown>(
 params: EventsStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsStream>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsStreamQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Every delivery the caller can see, across all trigger kinds — the workspace-wide feed. Narrow it with the `eventSourceId` / `webhookId` / `scheduleId` / `connectionId` filters, which take the same GIDs the per-trigger listings are addressed by.
 * @summary List recorded events
 */
export const eventList = (
    params: EventListParams,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<EventConnection>(
      {url: `/api/v1/events`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getEventListQueryKey = (params?: EventListParams,) => {
    return [
    `/api/v1/events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getEventListQueryOptions = <TData = Awaited<ReturnType<typeof eventList>>, TError = unknown>(params: EventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventList>>> = ({ signal }) => eventList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventListQueryResult = NonNullable<Awaited<ReturnType<typeof eventList>>>
export type EventListQueryError = unknown


export function useEventList<TData = Awaited<ReturnType<typeof eventList>>, TError = unknown>(
 params: EventListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventList>>,
          TError,
          Awaited<ReturnType<typeof eventList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventList<TData = Awaited<ReturnType<typeof eventList>>, TError = unknown>(
 params: EventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventList>>,
          TError,
          Awaited<ReturnType<typeof eventList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventList<TData = Awaited<ReturnType<typeof eventList>>, TError = unknown>(
 params: EventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List recorded events
 */

export function useEventList<TData = Awaited<ReturnType<typeof eventList>>, TError = unknown>(
 params: EventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a recorded event
 */
export const eventFindOne = (
    id: unknown,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<Event>(
      {url: `/api/v1/events/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getEventFindOneQueryKey = (id?: unknown,) => {
    return [
    `/api/v1/events/${id}`
    ] as const;
    }

    
export const getEventFindOneQueryOptions = <TData = Awaited<ReturnType<typeof eventFindOne>>, TError = unknown>(id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventFindOne>>> = ({ signal }) => eventFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof eventFindOne>>>
export type EventFindOneQueryError = unknown


export function useEventFindOne<TData = Awaited<ReturnType<typeof eventFindOne>>, TError = unknown>(
 id: unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventFindOne>>,
          TError,
          Awaited<ReturnType<typeof eventFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventFindOne<TData = Awaited<ReturnType<typeof eventFindOne>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventFindOne>>,
          TError,
          Awaited<ReturnType<typeof eventFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventFindOne<TData = Awaited<ReturnType<typeof eventFindOne>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a recorded event
 */

export function useEventFindOne<TData = Awaited<ReturnType<typeof eventFindOne>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Streams the raw bytes. 404 for a JSON payload — that is on the event itself.
 * @summary Read an event’s binary payload
 */
export const eventPayload = (
    id: unknown,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<void>(
      {url: `/api/v1/events/${id}/payload`, method: 'GET', signal
    },
      );
    }
  



export const getEventPayloadQueryKey = (id?: unknown,) => {
    return [
    `/api/v1/events/${id}/payload`
    ] as const;
    }

    
export const getEventPayloadQueryOptions = <TData = Awaited<ReturnType<typeof eventPayload>>, TError = unknown>(id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayload>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventPayloadQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventPayload>>> = ({ signal }) => eventPayload(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventPayload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventPayloadQueryResult = NonNullable<Awaited<ReturnType<typeof eventPayload>>>
export type EventPayloadQueryError = unknown


export function useEventPayload<TData = Awaited<ReturnType<typeof eventPayload>>, TError = unknown>(
 id: unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventPayload>>,
          TError,
          Awaited<ReturnType<typeof eventPayload>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventPayload<TData = Awaited<ReturnType<typeof eventPayload>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventPayload>>,
          TError,
          Awaited<ReturnType<typeof eventPayload>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventPayload<TData = Awaited<ReturnType<typeof eventPayload>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayload>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read an event’s binary payload
 */

export function useEventPayload<TData = Awaited<ReturnType<typeof eventPayload>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayload>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventPayloadQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Streams a single file part of a `multipart/form-data` delivery. Each part is stored as its own object, so this reads only the part asked for. 404 for any other payload shape or an out-of-range index; the form’s non-file fields are the event’s JSON payload.
 * @summary Read one file part of an event’s multipart payload
 */
export const eventPayloadPart = (
    id: unknown,
    index: number,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<void>(
      {url: `/api/v1/events/${id}/payload/parts/${index}`, method: 'GET', signal
    },
      );
    }
  



export const getEventPayloadPartQueryKey = (id?: unknown,
    index?: number,) => {
    return [
    `/api/v1/events/${id}/payload/parts/${index}`
    ] as const;
    }

    
export const getEventPayloadPartQueryOptions = <TData = Awaited<ReturnType<typeof eventPayloadPart>>, TError = unknown>(id: unknown,
    index: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayloadPart>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventPayloadPartQueryKey(id,index);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventPayloadPart>>> = ({ signal }) => eventPayloadPart(id,index, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && index), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventPayloadPart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventPayloadPartQueryResult = NonNullable<Awaited<ReturnType<typeof eventPayloadPart>>>
export type EventPayloadPartQueryError = unknown


export function useEventPayloadPart<TData = Awaited<ReturnType<typeof eventPayloadPart>>, TError = unknown>(
 id: unknown,
    index: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayloadPart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventPayloadPart>>,
          TError,
          Awaited<ReturnType<typeof eventPayloadPart>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventPayloadPart<TData = Awaited<ReturnType<typeof eventPayloadPart>>, TError = unknown>(
 id: unknown,
    index: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayloadPart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventPayloadPart>>,
          TError,
          Awaited<ReturnType<typeof eventPayloadPart>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventPayloadPart<TData = Awaited<ReturnType<typeof eventPayloadPart>>, TError = unknown>(
 id: unknown,
    index: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayloadPart>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one file part of an event’s multipart payload
 */

export function useEventPayloadPart<TData = Awaited<ReturnType<typeof eventPayloadPart>>, TError = unknown>(
 id: unknown,
    index: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventPayloadPart>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventPayloadPartQueryOptions(id,index,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Queues the fan-out again for this event, referencing the same payload rather than copying it. Subscribers that already ran for it are skipped unless `triggerBindingId` names one explicitly.
 * @summary Re-dispatch a recorded event
 */
export const eventDispatch = (
    id: unknown,
    eventDispatchInput: EventDispatchInput,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<ActionPayload>(
      {url: `/api/v1/events/${id}/dispatch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventDispatchInput, signal
    },
      );
    }
  


export const getEventDispatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventDispatch>>, TError,{id: unknown;data: EventDispatchInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof eventDispatch>>, TError,{id: unknown;data: EventDispatchInput}, TContext> => {

const mutationKey = ['eventDispatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventDispatch>>, {id: unknown;data: EventDispatchInput}> = (props) => {
          const {id,data} = props ?? {};

          return  eventDispatch(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EventDispatchMutationResult = NonNullable<Awaited<ReturnType<typeof eventDispatch>>>
    export type EventDispatchMutationBody = EventDispatchInput
    export type EventDispatchMutationError = unknown

    /**
 * @summary Re-dispatch a recorded event
 */
export const useEventDispatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eventDispatch>>, TError,{id: unknown;data: EventDispatchInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof eventDispatch>>,
        TError,
        {id: unknown;data: EventDispatchInput},
        TContext
      > => {

      const mutationOptions = getEventDispatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    